module.exports = __webpack_public_path__ + "static/img/tjmbg.e5e7e6a7.png";